import {FC} from 'react';
import ServiceRequests from '../../components/ServiceRequests';

import styles from './ServiceRequests.module.scss';

const ServiceRequestsPage: FC = () => {
  return (
    <div className={styles.serviceRequests}>
      <ServiceRequests />
    </div>
  );
};

export default ServiceRequestsPage;
